module.exports = "https://coursera_assets.s3.amazonaws.com/images/2826152f7993a804903da63a4e576c51.jpg";